import * as React from 'react';
import * as classNames from 'classnames';

interface SuccessWithMessageProps {
    message: string;
}

export default class SuccessWithMessage extends React.Component<SuccessWithMessageProps> {
    constructor(props: SuccessWithMessageProps) {
        super(props);
    }

    render() {
        const classes = classNames('fa', 'fa-check-circle', 'text-success', "fa-4x");

        return (
            <div>
                <p style={{ 'fontSize': 3 + 'rem' }} className="text-center">
                    <i className={classes} aria-hidden="true"></i>
                </p>
                <p className="text-center">{this.props.message}</p>
            </div>
        );
    }
}
